import { ReleaseFormType } from '@api'

export const rfGroupByTagType: Record<
  ReleaseFormType,
  'rfTag' | 'rfGuest' | 'rfPartner'
> = {
  document: 'rfPartner',
  user: 'rfTag',
  guest: 'rfGuest',
  link: 'rfPartner',
  unknown: 'rfPartner',
}
